// extracted by mini-css-extract-plugin
export default {"wrap":"Cards_wrap__Icyoo","title":"Cards_title__BaiTS","cards":"Cards_cards__BX01C","card":"Cards_card__9GwoT","icon":"Cards_icon__Gr2Ps","text":"Cards_text__uNmIL"};